import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Wrench,
  ShieldCheck,
  FileBarChart2,
  PhoneCall,
} from "lucide-react"; // Icons

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    {
      href: "/services",
      label: "Services",
      icon: <Wrench size={20} />,
    },
    {
      href: "/ourpolicies",
      label: "Policies",
      icon: <ShieldCheck size={20} />,
    },
    {
      href: "/openreport",
      label: "Open Report",
      icon: <FileBarChart2 size={20} />,
    },
    {
      href: "/getintouch",
      label: "Get in Touch",
      icon: <PhoneCall size={20} />,
    },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="navbar flex items-center justify-between p-4 shadow-md bg-white">
      {/* Logo */}
      <a href="/" className="flex items-center">
        <img
          src="/Images/SB_Logo.png"
          className="h-16 w-16 object-contain"
          alt="Logo"
        />
      </a>

      {/* Desktop nav */}
      <div className="hidden md:flex gap-6 items-center">
        {navLinks.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className={`flex flex-col items-center justify-center px-3 py-1 rounded-md transition-all duration-200 ${
              isActive(link.href)
                ? "text-blue-600 font-semibold border-b-2 border-blue-500"
                : "text-gray-700 hover:text-blue-500"
            }`}
          >
            {link.icon}
            <span className="text-sm mt-1">{link.label}</span>
          </a>
        ))}
      </div>

      {/* Mobile menu */}
      <div className="md:hidden">
        <button
          className="p-2 rounded-md focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            className="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        {isMenuOpen && (
          <div className="absolute top-20 right-0 w-full bg-white shadow-lg z-10 p-4 space-y-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`flex items-center gap-2 px-4 py-2 rounded ${
                  isActive(link.href)
                    ? "bg-blue-100 text-blue-700 font-semibold"
                    : "hover:bg-gray-100 text-gray-800"
                }`}
              >
                {link.icon}
                {link.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NavBar;
